export interface IAppErrorOptions {
  code: string;
  message: string;
  metadata?: Record<string, unknown>;
  cause?: unknown;
}

export class AppError extends Error {
  readonly code: string;
  readonly metadata: Record<string, unknown>;
  readonly cause?: unknown;

  constructor(options: IAppErrorOptions) {
    super(options.message);
    this.name = 'AppError';
    this.code = options.code;
    this.metadata = options.metadata ?? {};
    this.cause = options.cause;
  }
}
